import React from 'react';
import PageForm from "components/pageForm";
import {Outlet} from "react-router-dom";
import PersonalInformationSubNav
    from "components/subNav/personalInformation.subNav";
import SubNavbar from "components/SubNavbar/SubNavbar";

const PersonalInformation = () => {
    return (
        <>
            <PageForm>
                <SubNavbar>
                    <div className="w-full flex items-end h-full">
                        <div className="w-full flex items-end">
                            <PersonalInformationSubNav/>
                        </div>
                    </div>
                </SubNavbar>
                <div className="col-span-12">
                    <Outlet/>
                </div>
            </PageForm>
        </>
    );
};

export default PersonalInformation;